import { render, staticRenderFns } from "./event-info.vue?vue&type=template&id=f866938c&scoped=true"
import script from "./event-info.ts?vue&type=script&lang=js&external"
export * from "./event-info.ts?vue&type=script&lang=js&external"
import style0 from "./event-info.less?vue&type=style&index=0&id=f866938c&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f866938c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f866938c')) {
      api.createRecord('f866938c', component.options)
    } else {
      api.reload('f866938c', component.options)
    }
    module.hot.accept("./event-info.vue?vue&type=template&id=f866938c&scoped=true", function () {
      api.rerender('f866938c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/event/event-info/event-info.vue"
export default component.exports